import React, { useEffect } from 'react';
import Carousel from '../Carousel/Carousel';
import UltimasNoticias from '../UltimasNoticias/UltimasNoticias';
// import Popup from '../Pop up/pop_up';
import './inicio.css';
import { titular } from '../../json/titular';
import { Link } from 'react-router-dom';
//import ModalConvocatoria from '../Modal/ModalConvocatoria';
import { carouselInicio } from '../../json/carousel';

const Inicio = () => {
  // const [showPopup, setShowPopup] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // const handleClosePopup = () => {
  //   setShowPopup(false);
  // };

 // const handleButtonClick = () => {
 //   window.location.href = '../quejas';
 //   console.log('Botón clickeado');
 // }; 
  
  return (
    <>
      {/* {showPopup && <Popup onClose={handleClosePopup} />} */}
      <Carousel bannerData={carouselInicio} search={true} name="banner-principal" />
       <div className='container'>
   {/*    <button 
    //    className="quejas_logo"
    //    onClick={() => handleButtonClick()}
      >
  <div className="quejas_logo_img" style={{ backgroundImage: 'url("assets/imgs/quejas.png")' }}></div>
  </button> */}
        <div className='row'>
          <div className='col-12'>
          <p></p>
          <div className='secretaria_logo' >
             <div className='secretaria_logo_img' style={{backgroundImage: 'url("assets/imgs/SEMOT.gif")'}}>
            </div>
            <br></br>
              </div>
              <br></br>
            <div className='secretaria_name'>
          <p></p>
          <h1>SECRETARÍA DE MOVILIDAD Y TRANSPORTE</h1>
          </div>
          <br></br>
          <div className='secretaria_funciones'>
            <h3 className='title'>FUNCIONES</h3>
            <hr className='hr-gob'/>
            <p> De conformidad a la Ley de Movilidad y Transporte para el estado de Hidalgo, es competencia de la Secretaría de Movilidad y Transporte, entre otras: (Capítulo III de las Atribuciones de la Secretaría de Movilidad y Transporte artículo 7):</p>
            <br></br>
            <p>
            <li>Formular, elaborar, revisar, coordinar y dar seguimiento a los Programas de Movilidad y Transporte;</li>
            <li>Implementar las medidas necesarias para prevenir y atender la violencia contra las mujeres por razón de género, en específico el acoso sexual contra de las mujeres en las unidades de servicio público de transporte, de conformidad con lo establecido en la Ley de Acceso de las Mujeres a una Vida Libre de Violencia para el Estado de Hidalgo;</li>
            <li>Fomentar el uso del transporte no motorizado, y los desplazamientos a pie, así como la accesibilidad para la movilidad de las personas con discapacidad o movilidad reducida;</li>
            <li>Implementar políticas y mecanismos de profesionalización de conductores de los servicios de transporte, a través de la capacitación, evaluación y certificación de sus competencias laborales, que incluyan las relacionadas con la materia de seguridad con perspectiva de género;</li>
            <li>Otorgar, modificar, transferir, extinguir, revocar y rescindir mancomunadamente con el Organismo del Transporte Convencional o con el Organismo del Transporte Masivo, según el caso de que se trate, las concesiones, permisos, autorizaciones, convenios y contratos materia de esta Ley; y, cuando así sea necesario con base a los estudios correspondientes, acordar la apertura o el cierre de plazas para el otorgamiento de las concesiones, permisos y autorizaciones materia de esta Ley;</li>
            <li>Vigilar y supervisar que el Organismo del Transporte Convencional proceda correctamente en todo cuanto se refiere a la regulación y vigilancia de la prestación de los Servicios de Transporte Colectivo, Individual, Privado y Complementario y a los Servicios Auxiliares y Conexos a ellos; así como que el Organismo del Transporte Masivo efectúe la adecuada regulación y vigilancia relativa al Servicio Público de Transporte Masivo, al Servicio de Pago Electrónico, a la operación del Centro General de Gestión de Operaciones y a los Servicios Auxiliares y Conexos a ellos.</li>
            </p>
           </div>
           </div>
           </div>

           <div className='btn_organigrama'>
           <a href= 'https://transparenciadocs.hidalgo.gob.mx/dependencias/Semot/dir3/Estructura%20Movilidad%20actual1.pdf'><button type="button" className="btn btn-primary">Organigrama</button></a>
           <a href= 'https://movilidadytransporte.hidalgo.gob.mx/Transparencia/htm/a69_f01SEMOT.htm'><button type="button" className="btn btn-primary">Normatividad</button></a>
           </div>

           <p></p>
           <br></br>
      <UltimasNoticias/>  
        <div className='row'>
          <div className='col-12'>
            <br></br>
            <div className='notes_title'>           
              <h3 className='title'>TITULAR DE LA SECRETARÍA</h3>
              <hr className='hr-gob'/>
            </div>
            <div className='section_notes'>
              {
                titular.map((item, index) =>(
                    <>
                      <div key={ index } className='sec_photo'>
                        <div className='img_secretario' style={{ backgroundImage: `url("${ item.imagen }")` }}>
                        </div>
                      </div>
                      <div className='sec_container'>
                        <div className='sec_name'>
                          <h3>{ item.nombre }</h3>
                        </div>
                      {  <div className='sec_function'>
                          <h4>Conoce a la Secretaria</h4>
                          <p>{ item.funcion }</p>
                          <div className='btn_agenda'>
                            <Link to="Agenda">Agenda de la Secretaria</Link>
                </div> 
                        </div> }
                      </div>
                    </>
                ))
              }
            </div>
          </div>
        </div>
        <br></br>
         <div className='row'>
          <div className='col-12'>
            <div className='section_map'>
              <div className='map_name'>
                <p></p>
                <h3 className='title'>UBICACIÓN</h3>
                <hr className='hr-gob'/>
              </div>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1873.206677158688!2d-98.74496293044369!3d20.116795698832142!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d10900728b2db3%3A0xff3afc128f74ecd1!2sSecretar%C3%ADa%20de%20Movilidad%20y%20Transporte!5e0!3m2!1ses!2smx!4v1720457528374!5m2!1ses!2smx"title="Ubicación de la Secretaría de Movilidad y Transporte" width="100%" height="300"frameBorder="0"style={{ border: 0, marginBottom: 50 }}  allowFullScreen> 
              </iframe>
            </div> 
           </div>
        </div>   
      </div>
     </>
  )
}

export default Inicio